import { FC, ReactNode, useState } from 'react';

import Box from '@mui/material/Box';
import Nav from './nav';
import Main from './main';
import Header from './header';

// ----------------------------------------------------------------------

const DashboardLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const [openNav, setOpenNav] = useState(false);

  return (
    <>
      <Header onOpenNav={() => setOpenNav(true)} />

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' }
        }}
      >
        <Nav openNav={openNav} onCloseNav={() => setOpenNav(false)} />

        <Main>{children}</Main>
      </Box>
    </>
  );
};

export default DashboardLayout;
